module.exports = __webpack_public_path__ + "static/img/page_build_img.1eecbba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_build_img.png
// module id = pb5Q
// module chunks = 1